import React, { useEffect, useState } from 'react'
import { Table } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import "./ProjectSiteSupervisorTable.scss"
import { image } from '../../../../app/utils/common/image';
import TableComponent from '../../../atoms/TableComponent/Tablecomponent';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../app/utils/hooks/reduxHook';
import { PaginationType } from '../../../../dto/Pagination.dto';
import { MAX_TABLE_DATA_PER_PAGE } from '../../../../app/utils/apis/Constant';
import { getProjectManagerAPI, getProjectSiteVisitorAPI } from '../../../../redux/API/ProjectAPI';
import { ManagerType } from '../../../../dto/Manager.dto';
import { getImageURL } from '../../../../app/utils/common/getImageUrl';
import { SiteSupervisorType } from '../../../../dto/SiteSupervisor.dto';



const ProjectSiteSupervisorTable: React.FC = () => {

    const { SingleProject, SingleProjectSiteSupervisors } = useAppSelector(state => state.project);
    const [pagination, setPagination] = useState<PaginationType>({
        current_page: 1,
        total_data: 10,
        total_pages: 1,
        page_size: MAX_TABLE_DATA_PER_PAGE
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const columns: TableColumnsType<SiteSupervisorType> = [
        {
            title: 'Profile',
            dataIndex: 'profile',
            render: (text, record) => (
                <img
                    src={record.profile_image ? getImageURL(record.profile_image) : image.DEFAULT_PROFILE_IMAGE}
                    alt="Profile"
                    style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                />
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Phone Number',
            dataIndex: 'phone_number',
        },
    ];

    useEffect(() => {
        if (SingleProject && !loading) {
            setLoading(true);
            dispatch(getProjectSiteVisitorAPI({ project_id: SingleProject.project_id, current_page: pagination.current_page })).unwrap()
                .then((data: {
                    site_supervisors_data: any,
                    pagination: PaginationType
                }) => {
                    if (data.pagination.current_page === pagination.current_page) {
                        setPagination(data.pagination);
                    }
                }).catch((error) => { console.log("error in fetching site supervisor for project", error) }).finally(() => { setLoading(false) })
        }
    }, [pagination.current_page]);

    const handlePageChange = (pageNumber: number) => {
        setPagination({ ...pagination, current_page: pageNumber });
    };
    return (
        <div className='manager_dataTable' style={{ marginTop: "0" }}>
            <div>
                <TableComponent columns={columns}
                    dataSource={SingleProjectSiteSupervisors}
                    loading={loading}
                    pageNumbers={Array.from({ length: pagination?.total_pages }, (_, index) => index + 1)}
                    handlePageLink={handlePageChange}
                    isPagination={pagination?.total_pages > 1}
                    totalProfile={pagination?.total_data}
                    prevPage={() => handlePageChange(pagination?.current_page - 1)}
                    nextPage={() => handlePageChange(pagination?.current_page)}
                    activePage={pagination?.current_page}
                    currentTotal={Math.min(pagination?.current_page * pagination?.page_size, (SingleProjectSiteSupervisors ?? []).length)} />
            </div>
        </div>
    )
}

export default ProjectSiteSupervisorTable
